<ng-container *transloco="let t; read: 'user'">
  @if (studentInfo) {
    <div>
      <div class="grid grid-cols-1 md:grid-cols-3 gap-3 mt-5 px-0">
        <div class="flex flex-wrap">
          <div class="w-2/5">{{ t('inputRating.studentInfo.child') }}</div>
          <div class="w-3/5 font-bold">{{studentInfo.studentName}}</div>
        </div>
        <div class="flex flex-wrap">
          <div class="w-2/5">{{ t('inputRating.studentInfo.districtAgency') }}</div>
          <div class="w-3/5 font-bold">{{studentInfo.agencyName}}</div>
        </div>
        <div class="flex flex-wrap">
          <div class="w-2/5">{{ t('inputRating.studentInfo.classroomEnrollmentDate') }}</div>
          <div class="w-3/5 font-bold">{{studentInfo.enrollmentDate | localizedDate: 'longDate'}}</div>
        </div>
        <div class="flex flex-wrap">
          <div class="w-2/5">{{ t('inputRating.studentInfo.class') }}</div>
          <div class="w-3/5 font-bold">{{studentInfo.classroomName}}</div>
        </div>
        <div class="flex flex-wrap">
          <div class="w-2/5">{{ t('inputRating.studentInfo.schoolOrSite') }}</div>
          <div class="w-3/5 font-bold">{{studentInfo.siteName}}</div>
        </div>
        <div class="flex flex-wrap">
          <div class="w-2/5">{{ t('inputRating.studentInfo.assessmentDate') }}</div>
          <div class="w-3/5 font-bold">{{studentInfo.assessmentDate | localizedDate: 'longDate'}}</div>
        </div>
        <div class="flex flex-wrap">
          <div class="w-2/5">{{ t('inputRating.studentInfo.teacher') }}</div>
          <div class="w-3/5 font-bold">{{studentInfo.teacherName}}</div>
        </div>
        <div class="flex flex-wrap">
          <div class="w-2/5">{{ t('inputRating.studentInfo.ageGroupInstrument') }}</div>
          <div class="w-3/5 font-bold">{{studentInfo.ageGradeInstrumentName}} @if (studentInfo.isCustom) {
            <span
            >{{ t('inputRating.studentInfo.custom') }}</span>
          }</div>
        </div>
        <div class=" flex flex-wrap">
          <div class="w-2/5">{{ t('inputRating.studentInfo.lockDate') }}</div>
          <div class="w-3/5 font-bold">{{studentInfo.lockingDate | localDate | localizedDate: 'longDate'}}</div>
        </div>
      </div>
      @if (hasMeasures && studentInfo.templateUrl) {
        <div class="md:flex place-content-between place-items-center self-center mt-5"
          >
          <!-- One sentence with an inline link to the server-supplied instrument URL, so it is rendered as a single translated HTML string. -->
          <p class="text-sm" [innerHTML]="t('inputRating.studentInfo.instrumentNotice', { url: studentInfo.templateLink })">
        </p>
      </div>
    }
    @if (isRatingDisabled) {
      <div class="md:flex place-content-between place-items-center bg-[#ed4c4c] text-white self-center mt-5 rounded-3xl py-4 px-3"
        >
        <p class="text-sm">
          <ng-container>
            @if (isRatingViewRejected) {
              {{ ratingViewRejectedMessage }}
            } @else {
              {{ t('inputRating.studentInfo.ratingsDisabled') }}
            }
          </ng-container>
        </p>
      </div>
    }
    <div class="flex flex-wrap justify-end items-end space-x-2 mt-2">
      <div><a class="text-sm cursor-pointer" (click)="goBack()"><i
      class="uil uil-angle-left-b text-base"></i>{{ t('inputRating.studentInfo.backToViewClass') }}</a></div>
      @if (isScantron && !studentInfo.isLocked && canSaveRatings) {
        <drdp-btn
          (click)="onActionClick(InputRatingAction.Save)" color="outline">
          <i class="text-drdpblue-300 text-xl uil uil-save"></i>
        {{ t('inputRating.common.save') }}</drdp-btn>
      }
      <drdp-btn (click)="onActionClick(InputRatingAction.Previous)" color="outline"> <i
      class="text-drdpblue-300 text-xl uil uil-previous"></i>
    {{ t('inputRating.studentInfo.previous') }}</drdp-btn>
    <drdp-btn (click)="onActionClick(InputRatingAction.Next)" color="outline"> <i
    class="text-drdpblue-300 text-xl uit uil-step-forward"></i>
  {{ t('inputRating.studentInfo.next') }}</drdp-btn>
  <drdp-btn (click)="onActionClick(InputRatingAction.Print)" color="outline"> <i
  class="text-drdpblue-300 text-xl uil uil-print"></i>
  {{ t('inputRating.studentInfo.print') }}</drdp-btn>
  @if (!studentInfo.isLocked && canLockRatings && !isRatingDisabled) {
    <drdp-btn
      (click)="onActionClick(InputRatingAction.Lock)" color="outline">
      <i class="text-drdpblue-300 text-xl uil uil-lock"></i>{{ t('inputRating.common.lock') }}</drdp-btn>
    }
    @if (studentInfo.isLocked && canUnlockRatings && !isRatingDisabled) {
      <drdp-btn
        (click)="onActionClick(InputRatingAction.Unlock)" color="outline">
        <i class="text-drdpblue-300 text-xl uil uil-unlock"></i>
      {{ t('inputRating.common.unlock') }}</drdp-btn>
    }
  </div>
  </div>
  }
</ng-container>
